export class ESportParticipationTypeCode {
    public static readonly Compete = 'C';
    public static readonly DidNotCompete = 'N';
    public static readonly RemovedFromTeam = 'X';
    public static readonly Manager = 'M';
    public static readonly PracticeOnly = 'P';
}
export class ESportParticipationType {
    public static readonly Compete = 1;
    public static readonly DidNotCompete = 2;
    public static readonly RemovedFromTeam = 3;
    public static readonly Manager = 4;
    public static readonly PracticeOnly = 5;
}